import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';

const mediaClasses = 'overflow-hidden relative';

export const Inline1 = (header, body, media, dataTestIdForTextDiv) => (
  <div className="flex flex-col gap-20 sm:flex-row sm:items-start sm:justify-between">
    {media && <div className={classnames(mediaClasses, 'rounded-12 sm:w-1/2')}>{media}</div>}
    {(header || body) && (
      <div className={classnames({ 'sm:w-1/2': media })} data-testid={dataTestIdForTextDiv}>
        {header}
        {body && <div className={header && 'mt-20'}>{body}</div>}
      </div>
    )}
  </div>
);

export const Inline2 = (header, body, media, dataTestIdForTextDiv) => (
  <div className="flex flex-col gap-20 sm:flex-row-reverse sm:items-start sm:justify-between">
    {media && <div className={classnames(mediaClasses, 'rounded-12 sm:w-1/2')}>{media}</div>}
    {(header || body) && (
      <div className={classnames({ 'sm:w-1/2': media })} data-testid={dataTestIdForTextDiv}>
        {header}
        {body && <div className={header && 'mt-20'}>{body}</div>}
      </div>
    )}
  </div>
);

export const Column1 = (header, body, media) => (
  <Fragment>
    {media && <div className={classnames(mediaClasses, 'rounded-12')}>{media}</div>}
    {header && <div className={media && 'mt-20'}>{header}</div>}
    {body && <div className={(media || header) && 'mt-20'}>{body}</div>}
  </Fragment>
);

export const Column2 = (header, body, media) => (
  <div className="h-full overflow-hidden rounded-12 shadow-subtle">
    {media && <div className="-mx-1 -mt-1">{media}</div>}
    {(header || body) && (
      <div className="p-20">
        {header}
        {body && <div className={header && 'mt-20'}>{body}</div>}
      </div>
    )}
  </div>
);

export const Composite1 = (header, body, media) => (
  <Fragment>
    {media && <div className={classnames(mediaClasses, 'rounded-12')}>{media}</div>}
    {(header || body) && (
      <div className={classnames('flex flex-col gap-20 sm:flex-row', { 'mt-20': media })}>
        {header && <div className="sm:flex-1">{header}</div>}
        {body && <div className={classnames('sm:flex-1', { 'mt-20': header })}>{body}</div>}
      </div>
    )}
  </Fragment>
);
